// extracted by mini-css-extract-plugin
module.exports = {"main":"ResourceUtilizationReportStyles_main__3JjBM","doubleCardRow":"ResourceUtilizationReportStyles_doubleCardRow__1_S6y"};